import { render, staticRenderFns } from "./TalimatGuncelle.vue?vue&type=template&id=68c2069d&"
import script from "./TalimatGuncelle.vue?vue&type=script&lang=js&"
export * from "./TalimatGuncelle.vue?vue&type=script&lang=js&"
import style0 from "./TalimatGuncelle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports